import { CameraIcon } from '@heroicons/react/16/solid';
import { useRef } from 'react';

type AddImageProps = {
  handleChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  image?: File | string | null;
  imageType?: 'cover' | 'back';
};

export const AddImage = ({ handleChange, image, imageType = 'cover' }: AddImageProps) => {
  const hiddenFileInput = useRef<HTMLInputElement>(null);
  const handleClick = () => {
    hiddenFileInput.current?.click();
  };

  return (
    <>
      <button
        className="button-upload h-full"
        onClick={handleClick}
        style={{ width: '100%', height: '100%' }}>
        {image ? (
          <img
            src={typeof image === 'string' ? image : URL.createObjectURL(image)}
            alt="Book cover"
            className="w-full rounded-lg"
          />
        ) : (
          <div className="border-2 border-dashed border-cyan-700 rounded-lg p-4 h-full flex flex-col items-center justify-center">
            <CameraIcon className="size-8 mx-auto text-cyan-700" />
            <p className="mt-3 text-xs font-bold">Add book's {imageType}</p>
            <p className="mt-1 text-xs text-cyan-600">
              {imageType === 'cover' ? '(Required)' : '(Optional)'}
            </p>
          </div>
        )}
      </button>
      <input
        ref={hiddenFileInput}
        type="file"
        style={{ display: 'none' }}
        onChange={handleChange}
        accept="image/*"
      />
    </>
  );
};
